const _temp0 = require("../Error.js");
const _temp1 = require("../Layout.js");
const _temp2 = require("../NotFound.js");
const _temp3 = require("../Page.js");
const _temp4 = require("../about/Page.js");

const _temp5 = require("../accounts/Layout.js");
const _temp6 = require("../accounts/Page.js");
const _temp7 = require("../accounts/:id/Page.js");
const _temp8 = require("../accounts/:id/documents/request/Error.js");
const _temp9 = require("../accounts/:id/documents/request/Page.js");




const _temp10 = require("../apps/Layout.js");
const _temp11 = require("../apps/Page.js");
const _temp12 = require("../apps/:host/Page.js");


const _temp13 = require("../connections/Layout.js");
const _temp14 = require("../connections/Page.js");
const _temp15 = require("../connections/:host/Layout.js");
const _temp16 = require("../connections/:host/Page.js");
const _temp17 = require("../connections/:host/history/Page.js");

const _temp18 = require("../connections/:host/sharing/Page.js");

const _temp19 = require("../connections/:host/data/request/Error.js");
const _temp20 = require("../connections/:host/data/request/Page.js");




const _temp21 = require("../contact/Page.js");

const _temp22 = require("../data/Layout.js");
const _temp23 = require("../data/Page.js");
const _temp24 = require("../data/:documentId/Layout.js");
const _temp25 = require("../data/:documentId/Page.js");
const _temp26 = require("../data/:documentId/history/Page.js");

const _temp27 = require("../data/:documentId/sharing/Page.js");


const _temp28 = require("../data/new/Page.js");
const _temp29 = require("../data/new/:documentTypeId/Page.js");


const _temp30 = require("../data/types/Page.js");
const _temp31 = require("../data/types/:documentTypeId/Page.js");
const _temp32 = require("../data/types/:documentTypeId/edit/Page.js");


const _temp33 = require("../data/types/new/Page.js");



const _temp34 = require("../developer/Page.js");

const _temp35 = require("../documents/Layout.js");
const _temp36 = require("../documents/Page.js");
const _temp37 = require("../documents/:documentId/Layout.js");
const _temp38 = require("../documents/:documentId/Page.js");
const _temp39 = require("../documents/:documentId/events/Page.js");

const _temp40 = require("../documents/:documentId/sharing/Page.js");


const _temp41 = require("../documents/new/Page.js");

const _temp42 = require("../documents/types/Page.js");
const _temp43 = require("../documents/types/:documentTypeId/Page.js");
const _temp44 = require("../documents/types/:documentTypeId/edit/Page.js");


const _temp45 = require("../documents/types/new/Page.js");



const _temp46 = require("../events/Page.js");

const _temp47 = require("../help/Page.js");

const _temp48 = require("../history/Page.js");

const _temp49 = require("../notifications/Page.js");

const _temp50 = require("../pricing/Page.js");

const _temp51 = require("../privacy/Page.js");

const _temp52 = require("../security/Page.js");

const _temp53 = require("../settings/Layout.js");
const _temp54 = require("../settings/Page.js");
const _temp55 = require("../settings/apps/Page.js");
const _temp56 = require("../settings/apps/:host/Page.js");

const _temp57 = require("../settings/apps/new/Page.js");


const _temp58 = require("../settings/oauth/Page.js");

const _temp59 = require("../settings/password/Page.js");

const _temp60 = require("../settings/sessions/Page.js");


const _temp61 = require("../signin/Page.js");
const _temp62 = require("../signin/email/verify/Page.js");



const _temp63 = require("../signout/Page.js");

const _temp64 = require("../styleguide/Layout.js");
const _temp65 = require("../styleguide/Page.js");
const _temp66 = require("../styleguide/AppIcon/Page.js");

const _temp67 = require("../styleguide/Button/Page.js");

const _temp68 = require("../styleguide/Typography/Page.js");


const _temp69 = require("../terms/Page.js");

const _temp70 = require("../login/to/:host/Page.js");



module.exports = {
  "Error": _temp0,
  "Layout": _temp1,
  "NotFound": _temp2,
  "Page": _temp3,
  "about":   {
    "Page": _temp4
  },
  "accounts":   {
    "Layout": _temp5,
    "Page": _temp6,
    ":id":     {
      "Page": _temp7,
      "documents":       {
        "request":         {
          "Error": _temp8,
          "Page": _temp9
        }
      }
    }
  },
  "apps":   {
    "Layout": _temp10,
    "Page": _temp11,
    ":host":     {
      "Page": _temp12
    }
  },
  "connections":   {
    "Layout": _temp13,
    "Page": _temp14,
    ":host":     {
      "Layout": _temp15,
      "Page": _temp16,
      "history":       {
        "Page": _temp17
      },
      "sharing":       {
        "Page": _temp18
      },
      "data":       {
        "request":         {
          "Error": _temp19,
          "Page": _temp20
        }
      }
    }
  },
  "contact":   {
    "Page": _temp21
  },
  "data":   {
    "Layout": _temp22,
    "Page": _temp23,
    ":documentId":     {
      "Layout": _temp24,
      "Page": _temp25,
      "history":       {
        "Page": _temp26
      },
      "sharing":       {
        "Page": _temp27
      }
    },
    "new":     {
      "Page": _temp28,
      ":documentTypeId":       {
        "Page": _temp29
      }
    },
    "types":     {
      "Page": _temp30,
      ":documentTypeId":       {
        "Page": _temp31,
        "edit":         {
          "Page": _temp32
        }
      },
      "new":       {
        "Page": _temp33
      }
    }
  },
  "developer":   {
    "Page": _temp34
  },
  "documents":   {
    "Layout": _temp35,
    "Page": _temp36,
    ":documentId":     {
      "Layout": _temp37,
      "Page": _temp38,
      "events":       {
        "Page": _temp39
      },
      "sharing":       {
        "Page": _temp40
      }
    },
    "new":     {
      "Page": _temp41
    },
    "types":     {
      "Page": _temp42,
      ":documentTypeId":       {
        "Page": _temp43,
        "edit":         {
          "Page": _temp44
        }
      },
      "new":       {
        "Page": _temp45
      }
    }
  },
  "events":   {
    "Page": _temp46
  },
  "help":   {
    "Page": _temp47
  },
  "history":   {
    "Page": _temp48
  },
  "notifications":   {
    "Page": _temp49
  },
  "pricing":   {
    "Page": _temp50
  },
  "privacy":   {
    "Page": _temp51
  },
  "security":   {
    "Page": _temp52
  },
  "settings":   {
    "Layout": _temp53,
    "Page": _temp54,
    "apps":     {
      "Page": _temp55,
      ":host":       {
        "Page": _temp56
      },
      "new":       {
        "Page": _temp57
      }
    },
    "oauth":     {
      "Page": _temp58
    },
    "password":     {
      "Page": _temp59
    },
    "sessions":     {
      "Page": _temp60
    }
  },
  "signin":   {
    "Page": _temp61,
    "email":     {
      "verify":       {
        "Page": _temp62
      }
    }
  },
  "signout":   {
    "Page": _temp63
  },
  "styleguide":   {
    "Layout": _temp64,
    "Page": _temp65,
    "AppIcon":     {
      "Page": _temp66
    },
    "Button":     {
      "Page": _temp67
    },
    "Typography":     {
      "Page": _temp68
    }
  },
  "terms":   {
    "Page": _temp69
  },
  "login":   {
    "to":     {
      ":host":       {
        "Page": _temp70
      }
    }
  }
}